import { motion } from 'framer-motion';

const ProcessSteps = () => {
  const steps = [
    {
      number: '01',
      icon: 'ri-chat-3-line',
      title: 'Cuéntanos tu caso',
      description: 'Completa el formulario o contáctanos para evaluar tu situación y orientarte correctamente.',
      details: [
        'Formulario simple y directo',
        'Evaluación gratuita de tu situación',
        'Orientación clara sobre el proceso',
        'Sin compromisos ni letra chica',
      ],
      image: 'https://public.readdy.ai/ai/img_res/2d3b7fe5528d4a3a48500355a5409993.jpg',
    },
    {
      number: '02',
      icon: 'ri-search-eye-line',
      title: 'Revisamos y gestionamos',
      description: 'Analizamos los antecedentes y nos encargamos de todo el proceso legal según tu caso.',
      details: [
        'Revisión completa de antecedentes',
        'Gestión integral del proceso legal',
        'Coordinación con los organismos correspondientes',
        'Seguimiento permanente del trámite',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20lawyer%20carefully%20reviewing%20legal%20documents%20and%20files%20on%20desk%2C%20focused%20analysis%2C%20organized%20paperwork%2C%20modern%20law%20office%20with%20yellow%20accents%2C%20thorough%20legal%20research%20and%20document%20management%2C%20serious%20professional%20environment&width=600&height=400&seq=process-step-new-002&orientation=landscape',
    },
    {
      number: '03',
      icon: 'ri-shield-check-line',
      title: 'Avanzas sin complicaciones',
      description: 'Te acompañamos hasta completar el trámite y puedas disponer de los bienes sin problemas.',
      details: [
        'Acompañamiento hasta el cierre',
        'Resolución sin burocracia de tu parte',
        'Disposición efectiva de los bienes',
        'Soporte post-trámite incluido',
      ],
      image: 'https://readdy.ai/api/search-image?query=satisfied%20client%20shaking%20hands%20with%20professional%20lawyer%20in%20modern%20office%2C%20successful%20legal%20process%20completion%2C%20confident%20smiling%20people%2C%20clean%20minimalist%20law%20office%20with%20natural%20light%2C%20yellow%20accents%20on%20furniture%2C%20professional%20trust%20and%20achievement&width=600&height=400&seq=process-step-new-003&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-24">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative mb-6">
                  <span className="text-8xl font-black text-primary-yellow opacity-20">
                    {step.number}
                  </span>
                  <div className="absolute top-4 left-0 w-16 h-16 flex items-center justify-center bg-black rounded-2xl">
                    <i className={`${step.icon} text-3xl text-primary-yellow`}></i>
                  </div>
                </div>

                <h3 className="text-4xl font-bold text-black mb-4">
                  {step.title}
                </h3>
                <p className="text-lg text-gray-medium leading-relaxed mb-6">
                  {step.description}
                </p>

                <ul className="space-y-3">
                  {step.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-primary-yellow rounded-full flex-shrink-0 mt-1">
                        <i className="ri-check-line text-black text-sm font-bold"></i>
                      </div>
                      <span className="text-gray-dark">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="relative rounded-2xl overflow-hidden shadow-2xl"
                >
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-auto object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;